import classNames from "classnames";
import {FiAlertTriangle, FiCheck, FiLoader, FiStopCircle} from "react-icons/fi";

import {Accordion} from "@/components/accordion/Accordion.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {AnalyzerToolGroupActionProps} from "@/pages/analyzer/Analyzer.types.ts";
import {formatToolLabel} from "@/pages/analyzer/Analyzer.utils.ts";

import styles from "./AnalyzerToolGroupAction.module.scss";

export const AnalyzerToolGroupAction = ({toolCall, inProgress}: AnalyzerToolGroupActionProps) => {
  const {call, result} = toolCall;
  const isComplete = !!result;
  const status = result?.status_code ?? 0;
  const isServerError = status >= 500;
  const isWarning = !!result?.error || status >= 400;
  const label = formatToolLabel(call.tool, call.args, isComplete);
  const statusClass = isWarning ? styles.warning : styles.complete;

  if (!isComplete) {
    return (
      <div className={classNames(styles.action, styles.row, styles.pending)}>
        <Icon
          icon={inProgress ? FiLoader : FiStopCircle}
          className={classNames({pulseSpin: inProgress})}
          size="normal"
          removeDivDimensions
        />
        <span className={styles.label}>{label}</span>
      </div>
    );
  }

  return (
    <Accordion.Item eventKey={call.call_id} className={styles.action}>
      <Accordion.Header className={styles.row}>
        <Icon icon={isWarning ? FiAlertTriangle : FiCheck} size="normal" removeDivDimensions className={statusClass} />
        <span className={classNames(styles.label, statusClass)}>{label}</span>
      </Accordion.Header>
      <Accordion.Body className={styles.result}>
        {status >= 400 && (
          <div className={classNames(styles.note, {[styles.warning]: isWarning})}>
            {isServerError
              ? `The page responded with a server error (HTTP ${status}). Please try again later.`
              : `The page responded with an error (HTTP ${status}). Monitoring can still be created for it.`}
          </div>
        )}
        <pre className={styles.resultBlock}>{result.result}</pre>
        {result.screenshot && (
          <img
            src={`data:${result.screenshot.mime_type};base64,${result.screenshot.base64}`}
            alt={`${label} screenshot`}
            className={styles.screenshot}
          />
        )}
      </Accordion.Body>
    </Accordion.Item>
  );
};
